import { NotificationService } from '../services/NotificationService';

export function useNotificationService(): NotificationService {
  return new NotificationService(useApiClient(), useUserStore());
}
